<template>
  <div
    class="plan-card"
    :class="{ active: selected }"
    @click="$emit('select', plan)"
  >
    <div v-if="plan.subName" class="plan-badge">{{ plan.subName }}</div>
    <img v-if="selected" class="plan-corner" :src="cornerIcon" alt="" />
    <div class="plan-name">{{ plan.name }}</div>
    <div class="plan-price"><span class="unit">￥</span>{{ plan.price }}</div>
    <div class="plan-foot">
      <span class="plan-foot-text">
        {{ durationText }}，￥{{ plan.unitPrice }}/天
      </span>
    </div>
  </div>
</template>

<script>
import { planDurationText } from "@/utils/proPlan";

/**
 * 套餐卡片（套餐购买页）
 * plan: { id, name, subName, price, months, days, unitPrice, sort }
 */
export default {
  name: "PlanCard",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cornerIcon: require("@/assets/images/pro-plan/plan/plan-corner.png"),
    };
  },
  computed: {
    durationText() {
      return planDurationText(this.plan);
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-card {
  position: relative;
  // 4 张等分 1100 容器（≈261px，与设计稿一致）；不足 4 张时自动加宽铺满该行
  flex: 1 1 0;
  min-width: 0;
  height: 152px;
  padding: 30px 0 0;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e0e5ef;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border-color: #64c3a4;
  }
  &.active {
    border-color: #0fa87b;
    box-shadow: 0 4px 4px 0 rgba(15, 168, 123, 0.23);
  }
}
// 选中角标（设计稿切图，贴右上角）
.plan-corner {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 24px;
  height: 24px;
  display: block;
}
// 套餐子名称角标：位于卡片上沿（设计稿 1882:2091 y=-9），左移 1px 盖住卡片左边框
// （设计稿 x≈0 是相对边框外沿；不改则边框线从角标左侧露出，禅道 Bug#23428-2）
.plan-badge {
  position: absolute;
  top: -9px;
  left: -1px;
  padding: 4px 10px;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  white-space: nowrap;
  background: linear-gradient(180deg, #ffb81e 0%, #fb843a 100%);
  border-radius: 15px 15px 15px 0;
}
.plan-name {
  font-size: 20px;
  color: #333;
  line-height: 1.2;
}
.plan-price {
  // 设计稿「￥398」为整体 32px 文本，￥ 与数字同大小
  font-size: 32px;
  font-weight: 700;
  color: #0fa87b;
  line-height: 1.1;
}
// 底部时长胶囊：设计稿为通栏切图，贴卡片底边
.plan-foot {
  margin-top: auto;
  width: 100%;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  // 圆角须与卡片一致，否则切图的直角会溢出卡片圆角（禅道 Bug#23428-3）。
  // 卡片圆角 12px、边框 1px → 内侧圆角取 11px
  border-radius: 0 0 11px 11px;
  background: url("~@/assets/images/pro-plan/plan/plan-pill.png") no-repeat
    center / 100% 100%;
}
.plan-foot-text {
  font-size: 14px;
  color: #83ac91;
}
</style>
